import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const videoSocket = io(`${SOCKET_URL}/video`, {
  withCredentials: true,
  autoConnect: false,
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  timeout: 20000,
});

videoSocket.on('connect', () => {
  console.log('[VideoSocket] Connected:', videoSocket.id);
});

videoSocket.on('connect_error', (err) => {
  console.error('[VideoSocket] Connection error:', err.message);
});

videoSocket.on('disconnect', (reason) => {
  console.log('[VideoSocket] Disconnected:', reason);
});

export default videoSocket;